import { createRoot } from 'react-dom/client';
import '../src/i18n';
import ProductGrid from './components/catalog/ProductGrid';
import LanguageSwitcher from './components/LanguageSwitcher';

function CatalogApp() {
    return (
        <div className="ast-catalog-app">
            <div className="ast-catalog-app__header">
                <LanguageSwitcher />
            </div>
            <ProductGrid />
        </div>
    );
}

const container = document.getElementById('ast-catalog-root');
if (container) {
    const root = createRoot(container);
    root.render(<CatalogApp />);
}
